import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, MapPinIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
export function FloatingElements() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [index, setIndex] = useState(0);
  const [cta, setCta] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const delay = index === 0 ? 4500 : 7500;
    const showTimer = window.setTimeout(() => setVisible(true), delay);
    const rotateTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(value => (value + 1) % recentPurchases.length);
    }, delay + 5500);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(rotateTimer);
    };
  }, [dismissed, index]);
  useEffect(() => {
    const onScroll = () => setCta(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const [name, place] = recentPurchases[index];
  return <>
      <AnimatePresence data-id="element-140" data-mp="drhuafmhkcc2">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 26,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        type: 'spring',
        stiffness: 280,
        damping: 24
      }} className="fixed bottom-4 left-4 z-[60] max-w-[290px] overflow-hidden rounded-2xl border-[3px] border-gold bg-primary p-3 pr-8 shadow-[0_18px_42px_rgba(29,78,216,.45)]" aria-live="polite" data-id="element-141" data-mp="dpyd8mt09x98">
            <div className="absolute inset-y-0 left-0 w-1.5 bg-gold" data-id="element-142" data-mp="11gavaqhytadj" />
            <button onClick={() => setDismissed(true)} className="absolute right-1.5 top-1.5 rounded p-1 text-sky-100 transition-colors duration-150 ease-out hover:text-white" aria-label="Cerrar notificación" data-id="element-143" data-mp="15j77nzgwwa91">
              <XIcon className="h-3.5 w-3.5" data-id="element-144" data-mp="32j1yeb598yu9" />
            </button>
            <div className="flex gap-3" data-id="element-145" data-mp="32kwjbpgj0qyc">
              <span className="h-fit rounded-full border-2 border-amber-100 bg-gold p-2 text-white shadow-sm" data-id="element-146" data-mp="3ga6qms6amouk">
                <ShoppingBagIcon className="h-5 w-5" data-id="element-147" data-mp="3bj86fhi6p6m1" />
              </span>
              <div data-id="element-148" data-mp="3q8mhqv5bly42">
                <p className="flex items-center gap-1 text-[10px] font-black uppercase tracking-[.12em] text-amber-300" data-id="element-149" data-mp="3q84mo1ue9pxq">
                  <CheckCircle2Icon className="h-3 w-3" data-id="element-150" data-mp="3l8i217c8l7ew" /> Compra reciente
                </p>
                <p className="mt-1 text-xs leading-snug text-sky-50" data-id="element-151" data-mp="32viifvtwp57">
                  <b className="text-white" data-id="element-152" data-mp="3uahinyjca9hb">{name}</b> compró el libro digital{' '}
                  <b className="text-amber-200" data-id="element-153" data-mp="3u8eqb7ups49f">Combo Completo Fortalecimiento Lumbar 2026</b>
                </p>
                <p className="mt-1 flex items-center gap-1 text-[10px] font-semibold text-sky-100" data-id="element-154" data-mp="1zwginac1zgfn">
                  <MapPinIcon className="h-3 w-3 text-amber-300" data-id="element-155" data-mp="fefu5imjslpz" />
                  {place} · Argentina · hace {index * 5 + 2} min
                </p>
              </div>
            </div>
          </motion.aside>}
      </AnimatePresence>

      <AnimatePresence data-id="element-156" data-mp="6l2nzezh3nly">
        {cta && <motion.a href="#pricing" initial={{
        y: 80,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 80,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-3 left-3 right-3 z-50 rounded-2xl bg-primary py-3.5 text-center text-sm font-extrabold uppercase text-white shadow-lg shadow-primary/30 md:hidden" data-id="element-157" data-mp="anfui5m1npjs">
            💪 Quiero mi Combo Lumbar →
          </motion.a>}
      </AnimatePresence>
    </>;
}